module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (typeof _vm.user !== 'undefined') ? _c('div', [_c('div', {
    staticClass: "has-text-centered"
  }, [_c('strong', [_vm._v("Account Number:")]), _vm._v("\n    " + _vm._s(_vm.user.account_number ? _vm.user.account_number : 'N/A') + "\n    "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Billing")]), _vm._v(" "), (_vm.editingUser) ? _c('span', [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.editingUser = false
      }
    }
  }, [_vm._v("Stop Editing (lose changes)")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.editingUser) ? _c('user-form', {
    attrs: {
      "user": _vm.user
    },
    on: {
      "saved": function($event) {
        _vm.editingUser = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.editingUser) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-5"
  }, [_vm._v("\n          " + _vm._s(_vm.user.first_name) + " " + _vm._s(_vm.user.last_name) + " "), _c('br'), _vm._v("\n          " + _vm._s(_vm._f("phone")(_vm.user.phone)) + " "), _c('br'), _vm._v("\n          " + _vm._s(_vm.user.email) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_vm._v("\n          " + _vm._s(_vm.user.line1) + " " + _vm._s(_vm.user.line2) + " " + _vm._s(_vm.user.line3) + " "), _c('br'), _vm._v("\n          " + _vm._s(_vm.user.city) + ", " + _vm._s(_vm.user.state) + " " + _vm._s(_vm.user.zip) + " " + _vm._s(_vm.user.country) + " "), _c('br'), _vm._v("\n          Timezone: " + _vm._s(_vm.user.timezone) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.isSuperUser) ? _c('div', [(!_vm.editingUser) ? _c('button', {
    staticClass: "button is-small",
    on: {
      "click": function($event) {
        _vm.editingUser = true
      }
    }
  }, [_vm._v("Edit User")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Recipients")]), _vm._v(" "), _vm._l((_vm.recipients), function(recipient) {
    return _c('div', [(_vm.editingRecipient === recipient.id) ? _c('span', [_c('button', {
      staticClass: "button",
      on: {
        "click": function($event) {
          _vm.editingRecipient = false
        }
      }
    }, [_vm._v("Cancel Editing (lose changes)")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.editingRecipient === recipient.id) ? _c('user-recipient-form', {
      attrs: {
        "recipient": recipient
      },
      on: {
        "saved": function($event) {
          _vm.editingRecipient = false
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.editingRecipient !== recipient.id) ? _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column is-5"
    }, [_vm._v("\n            " + _vm._s(recipient.first_name) + " " + _vm._s(recipient.last_name) + " "), _c('br'), _vm._v("\n            " + _vm._s(_vm._f("phone")(recipient.phone)) + " "), _c('br'), _vm._v("\n            " + _vm._s(recipient.email) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "column"
    }, [_vm._v("\n            " + _vm._s(recipient.line1) + " " + _vm._s(recipient.line2) + " " + _vm._s(recipient.line3) + " "), _c('br'), _vm._v("\n            " + _vm._s(recipient.city) + " " + _vm._s(recipient.state) + " " + _vm._s(recipient.zip) + " " + _vm._s(recipient.country) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(recipient.residential ? 'Residential' : 'Commercial'))])])]) : _vm._e(), _vm._v(" "), (_vm.isSuperUser) ? _c('div', [(_vm.editingRecipient !== recipient.id) ? _c('a', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          _vm.editingRecipient = recipient.id
        }
      }
    }, [_vm._v("Edit Recipient")]) : _vm._e(), _vm._v(" "), (_vm.editingRecipient !== recipient.id) ? _c('span', [_vm._v("  ")]) : _vm._e(), _vm._v(" "), (_vm.editingRecipient !== recipient.id) ? _c('a', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.deleteRecipient(recipient)
        }
      }
    }, [_vm._v("Delete Recipient")]) : _vm._e(), _vm._v("\n            \n          "), (_vm.user.primary_recipient_id !== recipient.id) ? _c('a', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.setPrimaryRecipient(recipient)
        }
      }
    }, [_vm._v("Set Primary Recipient")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1)
  }), _vm._v(" "), (_vm.isSuperUser) ? _c('span', [(_vm.editingRecipient !== true) ? _c('button', {
    staticClass: "button is-small is-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.editingRecipient = true
      }
    }
  }, [_vm._v("Add Recipient\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.editingRecipient === true) ? _c('button', {
    staticClass: "button is-small",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.editingRecipient = false
      }
    }
  }, [_vm._v("\n                      Cancel Adding\n                  ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.editingRecipient === true) ? _c('div', [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.editingRecipient === true) ? _c('user-recipient-form', {
    attrs: {
      "create": true,
      "user-id": _vm.user.id
    },
    on: {
      "saved": function($event) {
        _vm.editingRecipient = false
      }
    }
  }) : _vm._e()], 1) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Orders")]), _vm._v(" "), (_vm.userOrders.length > 0) ? _c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.userOrders), function(order) {
    return _c('tr', [_c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'order',
          params: {
            id: order.id
          }
        }
      }
    }, [_vm._v("\n              " + _vm._s(order.id) + "\n\n            ")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")((order.discounted_total !== null ? order.discounted_total : order.total))) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(order.created_at, "from", "now")))])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.userOrders.length === 0) ? _c('div', {
    staticClass: "has-text-centered"
  }, [_vm._v("\n        User has placed no orders.\n      ")]) : _vm._e()])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Order #")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("Submitted")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04818856"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/users/User.vue
// module id = 494
// module chunks = 0